export const FOCUS_KEY_TO_MIXPANEL_EVENT_MAPPING = {
  grow_sales: 'Grow sales focus tap',
  attract_clients: 'Attract clients focus tap',
  retain_clients: 'Retain clients focus tap',
  get_churned_users: 'Get churned users focus tap',
  free_delivery: 'Free delivery focus tap',
  whole_menu_discount: 'Full menu discount focus tap',
  rating: 'Your rating increase focus tap',
  sales: 'Boost sales focus tap',
  new_promotion: 'Setup Promotion from scratch focus Tap',
};

export enum PromotionsAnalyticsEvents {
  opened_menu_selector = 'Promotions Menu Items Selector Opened',
  selected_items_promotion_created = 'Selected Items Promotion Created Using Menu Selector',
  double_deal_promotion_created = 'Double Deal Promotion Created',
  best_user_promotion_created = 'Regular Best User Promotion Created',
  dashboard_smart_promotions_banner_clicked = 'Smart Promotion Banner in Dashboard Clicked',
  promotions_list_smart_promotions_banner_clicked = 'Smart Promotion Banner in Regular Promotion List Clicked',
}
